import { useEffect, useState } from "react";
import axios from "axios";
import { BACKEND_URL } from "@/lib/api";

export const HourlyChart = ({ tick }) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/stats/hourly`, { withCredentials: true, headers: { "X-Doorman-Ledger": "sandbox" } })
      .then((r) => setRows(r.data)).catch(() => {});
  }, [tick]);

  const max = Math.max(1, ...rows.map((r) => r.count));
  const total = rows.reduce((s, r) => s + r.count, 0);

  return (
    <div className="rounded-md border border-[#222D3D] bg-[#141A24] p-5" data-testid="chart-presence-timeline">
      <div className="flex items-baseline justify-between mb-4">
        <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-slate-500">Simulated arrivals · last 24 hours</p>
        <p className="font-mono text-sm text-slate-200" data-testid="chart-total">{total.toLocaleString()}</p>
      </div>
      <div className="flex items-end gap-1 h-36">
        {rows.map((r) => (
          <div key={r.hour} className="flex-1 h-full flex flex-col justify-end group relative">
            <div className="bg-amber-500/70 group-hover:bg-amber-400 rounded-sm transition-colors" style={{ height: `${(r.count / max) * 100}%`, minHeight: r.count ? 2 : 0 }} />
            <span className="pointer-events-none absolute -top-6 left-1/2 -translate-x-1/2 font-mono text-[10px] text-slate-200 bg-[#07090E] border border-[#222D3D] rounded px-1 opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
              {r.count}
            </span>
          </div>
        ))}
      </div>
      <div className="flex justify-between mt-2 font-mono text-[10px] text-slate-600">
        {rows.filter((_, i) => i % 6 === 0).map((r) => <span key={r.hour}>{new Date(r.hour).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</span>)}
        <span>now</span>
      </div>
    </div>
  );
};
